import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { AverageageofsugarcaneInsertService } from '../../service/averageageofsugarcane-insert/averageageofsugarcane-insert.service';

@Component({
	selector: 'app-averageageofsugarcane-insert',
	templateUrl: './averageageofsugarcane-insert.component.html',
	providers: [
		AverageageofsugarcaneInsertService,
		HttpModule
	]
})
export class AverageageofsugarcaneInsertComponent implements OnInit {

	private token;
	public permissoes: any[] = [];
	average: FormGroup;
	Nome: string = "";
	statusAverage: boolean;

	constructor(fb: FormBuilder, private averageageofsugarcaneInsertService: AverageageofsugarcaneInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.average = fb.group({
			'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addAverage(value: any) {
		this.averageageofsugarcaneInsertService.insertAverage(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Idade Média Canavial cadastrada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/idade-media-canavial');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/idade-media-canavial');
	}

}


// WEBPACK FOOTER //
// ./src/app/averageageofsugarcane/component/averageageofsugarcane-insert/averageageofsugarcane-insert.component.ts